import { ReportsService } from '@/services/reports/reports.service';
import { StoreState } from '@/store';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { dateToString } from '@/utils/dateToString';
import { exportToExcel } from '@/utils/exportToExcel';
import { dateEndMustBeAfterDateStart } from '@/validators/dateEndMustBeAfterDateStart';
import { dateMustBeBeforeOrEqualThanToday } from '@/validators/dateMustBeBeforeOrEqualThanToday';
import { Component, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { GetReportLicense, ResponseFilterLicense, ResponseLicenseExcel, SelectedListToFilter, MultipleIdListToFilter } from '../../../../interfaces/reports/reports';
import { oneMustBeActiveOneOfEach, dateRangeConstraintByMonths } from '../reports.validators';

@Component({
  selector: 'app-reports-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.css'],
})
export class LicensesComponent implements OnInit {
  // to-do :  limpiar codico   comentarios  y clg
  @Input() assetList: SelectedListToFilter[] = [];

  @Input() zonesList: MultipleIdListToFilter[] = [];
  @Input() stateLicenseList: MultipleIdListToFilter[] = [];

  @Input() assetIdSelectedControl = new FormControl([]);
  @Input() resetFormControl: Subject<boolean> = new Subject<boolean>();

  @Input() gettingItemsList: boolean = true;
  @Input() gettingItemsListError: string = 'DEFAULT_VALUE';

  @Input() gettingZoneList: boolean = true;

  isRequestLicenseReport: boolean = false;
  detailLicenseByFilter?: ResponseFilterLicense[];
  gettingDetailsLicense: boolean = false;
  gettingLDetailsLicenseError: string = 'DEFAULT_VALUE';
  warning: boolean = false;
  pageCount: number = 0;
  listCountForPages: number[] = [];
  currentPage: number = 0;

  filterResult: string = 'license';
  assetIdSelected: Array<any> = [];

  assetId: number = 1;

  lastSubmitData?: GetReportLicense;

  listFilterAllAsset: FormControl = new FormControl();
  listFilterAllZones: FormControl = new FormControl();
  listFilterAllState: FormControl = new FormControl();

  assetsListsControl: FormArray = new FormArray([]);
  zonesListsControl: FormArray = new FormArray([]);
  stateListsControl: FormArray = new FormArray([]);

  @Output() controlForm: FormGroup = new FormGroup({});

  get pageNumberSelected(): FormControl {
    return this.controlForm.controls.pageNumberSelected as FormControl;
  }
  get dateFromReport(): FormControl {
    return this.controlForm.controls.fromDayReport as FormControl;
  }
  get dateUntilReport(): FormControl {
    return this.controlForm.controls.untilDayReport as FormControl;
  }
  get listFilterControlAsset(): FormArray {
    return this.controlForm.controls.listFilterControlAsset as FormArray;
  }
  // validaciones  calendarios

  get controlDateStartError(): string {
    const error = this.controlForm.controls.fromDayReport.errors;
    if (error) return error.description;
    return '';
  }
  // validaciones  calendarios

  get controlDateEndError(): string {
    const error = this.controlForm.errors;
    if (error && !error.hidden) return error.description;
    return '';
  }
  constructor(
    private reportsServices: ReportsService,
    private store: Store<StoreState>,
  ) { }

  ngOnInit(): void {
    this.controlForm = new FormGroup({
      fromDayReport: new FormControl(null, [Validators.required, dateMustBeBeforeOrEqualThanToday()]),
      untilDayReport: new FormControl(null, [Validators.required]),
      listFilterControlAsset: this.assetsListsControl,
      listFilterControlZones: this.zonesListsControl,
      listFilterControlStateLicenses: this.stateListsControl,
      pageNumberSelected: new FormControl(1),
    }, [
      dateEndMustBeAfterDateStart('fromDayReport', 'untilDayReport'),
      oneMustBeActiveOneOfEach('listFilterControlAsset', 'listFilterControlZones', 'listFilterControlStateLicenses'),
      dateRangeConstraintByMonths('fromDayReport', 'untilDayReport', 30),
    ]);

    this.controlForm.valueChanges.subscribe({
      next: (values) => {
        const valueAsset = values.listFilterControlAsset.filter(
          (id: any) => id.active,
        );
        const assetFiltered = (valueAsset as SelectedListToFilter[]).map(
          (item) => ({ id: item.id }),
        );
        this.assetIdSelected = assetFiltered;
      },
    });

    let defaultValueWasSetted = false;
    this.assetsListsControl.valueChanges.subscribe({
      next: (value) => {
        if (!defaultValueWasSetted) {
          defaultValueWasSetted = true;
          for (
            let index = 0;
            index < this.assetsListsControl.controls.length;
            index++
          ) {
            const formControl = this.assetsListsControl.at(index);
            if (index === 0) {
              formControl.patchValue({ active: true });
            }
            else {
              formControl.patchValue({ active: false });
            }
          }
        }
        this.onCheckAssetChange(value);
      },
    });

    this.listFilterAllAsset.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const formControl = this.assetsListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllZones.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.zonesListsControl.controls.length;
          index++
        ) {
          const formControl = this.zonesListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.listFilterAllState.valueChanges.subscribe({
      next: (isChecked) => {
        for (
          let index = 0;
          index < this.stateListsControl.controls.length;
          index++
        ) {
          const formControl = this.stateListsControl.at(index);
          formControl.patchValue({ active: isChecked });
        }
      },
    });
    this.resetFormControl.subscribe((response) => {
      if (response) {
        this.controlForm.patchValue({
          fromDayReport: null,
          untilDayReport: null,
        });

        const defaultControl = this.assetsListsControl.at(0);
        defaultControl.patchValue({ active: true });
        for (
          let index = 1;
          index < this.assetsListsControl.controls.length;
          index++
        ) {
          const control = this.assetsListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.zonesListsControl.controls.length;
          index++
        ) {
          const control = this.zonesListsControl.at(index);
          control.patchValue({ active: false });
        }
        for (
          let index = 0;
          index < this.stateListsControl.controls.length;
          index++
        ) {
          const control = this.stateListsControl.at(index);
          control.patchValue({ active: false });
        }

        this.isRequestLicenseReport = false;
      }
    });
  }

  onCheckAssetChange(value: Array<{ id: number; active: boolean }>) {
    this.assetIdSelectedControl.setValue(
      value.filter(({ active }) => active).map(({ id }) => id),
    );
  }
  onGetDetailReport(formDataReport?: GetReportLicense) {
    this.gettingDetailsLicense = true;
    const formData = this.controlForm.value;
    const selectedAsset = formData.listFilterControlAsset.filter(
      (value: any) => value.active,
    );
    const selectedZones = formData.listFilterControlZones.filter(
      (value: any) => value.active,
    );
    const selectedState = formData.listFilterControlStateLicenses.filter(
      (value: any) => value.active,
    );
    if (
      selectedAsset.length > 0
      || selectedZones.length > 0
      || selectedState.length > 0
    ) {
      const assetFiltered = selectedAsset.map((item: SelectedListToFilter) => ({
        id: item.id,
      }));
      const zoneFiltered = selectedZones.map((item: SelectedListToFilter) => ({
        id: item.id,
      }));
      const stateFiltered = selectedState.map((item: SelectedListToFilter) => ({
        id: item.id,
      }));

      let getFormDataReport: GetReportLicense = {
        dateStart: formData.fromDayReport,
        dateEnd: formData.untilDayReport,
        assets: assetFiltered,
        zones: zoneFiltered,
        licensesStatus: stateFiltered,
        pageNumber: formData.pageNumberSelected,
      };
      this.lastSubmitData = getFormDataReport;
      if (formDataReport) {
        getFormDataReport = formDataReport;
      }

      this.currentPage = <number>this.lastSubmitData?.pageNumber;

      this.reportsServices.getReportLicense(this.lastSubmitData).subscribe({
        next: (res) => {
          this.detailLicenseByFilter = res;
          if (res[0]) {
            this.pageCount = <number>res[0].pageCount;

          }
          this.getListNumberCount(this.pageCount);


          this.isRequestLicenseReport = true;
          this.gettingDetailsLicense = false;
        },
        error: () => {
          this.gettingDetailsLicense = false;
          this.gettingLDetailsLicenseError = 'Hubo un problema  al obtener el detalle de las Licencias';
        },
        complete: () => {
          // segundo dispatch
        },
      });
    }
    else {
      this.warning = true;
    }
  }

  getListNumberCount(pageCount: number) {
    const pagsArr: number[] = [];
    for (let i = 0; i < pageCount; i++) {
      pagsArr.push(i + 1);
      this.listCountForPages = pagsArr;
    }
  }

  getNextpage() {
    const currentPage = this.pageNumberSelected.value;
    if (currentPage) {
      this.pageNumberSelected.setValue(currentPage + 1);
      this.onGetDetailReport(this.lastSubmitData);

    }

  }
  getPreviusPage() {

    this.pageNumberSelected.setValue(this.currentPage - 1);
    this.onGetDetailReport(this.lastSubmitData);
  }

  getGotoNumberPage(numberPageSelected: number) {
    if (numberPageSelected) {
      this.pageNumberSelected.setValue(numberPageSelected);
      this.onGetDetailReport(this.lastSubmitData);
    }
  }

  // exportToExcel() {
  // type Keys = keyof ResponseFilterLicense;
  // const headers: Record<Keys, string> = {
  //   asset: 'Asset',
  //   driverName: 'Nombre Conductor',
  //   expirationDate: 'Empresa',
  //   zones: 'Zonas registradas',
  //   status: 'Estado',
  //   dateExpired: 'Fecha vencimiento',
  // };
  // const dataWithDateParsed = this.detailLicenseByFilter.map((data) => ({
  //   ...data,
  //   dateExpired: dateToString(data.dateExpired),
  // }));
  // exportToExcel(headers, dataWithDateParsed as any, 'Licencias');
  // }

  exportToExcel() {
    type Keys = keyof ResponseLicenseExcel;
    const headers: Record<Keys, string> = {
      names: 'Nombres ',
      lastnames: 'Apellidos ',
      rut: 'Rut ',
      email: 'Correo ',
      gender: 'Género ',
      emergencyContact: 'Contacto de Emergencia ',
      emergencyPhoneNumber: 'Número de Emergencia (Fijo) ',
      adress: 'Dirección ',
      management: 'Gerencia',
      entityType: 'Tipo de entidad(Empleado / Contratista)',
      company: 'Empresa',
      businessUnit: 'Unidad de Negocio',
      charge: 'Cargo',
      shiftSystem: 'Sistema Turno',
      licenseNumber: 'Número de Licencia',
      state: 'Estado',
      vehicleType: 'Vehículo',
      vehicleBrand: 'Marca',
      vehicleModel: 'Modelo',
      zone: 'Zona',
      licenseType: 'Tipo de Licencia',
      licenseValidity: 'Vigencia',
      licenseValidityComment: 'Comentario Vigencia',
      licenseExpirationDate: 'Fecha Vencimiento',
      licenseRestriction: 'Restricción',
      requestNumber: 'Numero de la solicitud',
      requestDate: 'Fecha de la solicitud',
      manualSuspensionDate: 'Fecha de suspencion manual',
      manualSuspensionDateFrom: 'Fecha de suspencion manual desde',
      manualSuspensionDateTo: 'Fecha de suspencion manual hasta',
      manualSuspensionResponsible: 'Responsable de suspencion manual',
      manualSuspensionResponsibleEmail: 'Correo responsable de suspencion manual',
      manualSuspensionResponsibleRut: 'Rut responsable de suspencion manual',
      approvalResponsible: 'Responsable de aprobacion',
      approvalResponsibleEmail: 'Correo responsable de aprobacion',
      approvalResponsibleRut: 'Rut responsable de aprobacion',
    };
    if (this.lastSubmitData) {
      this.store.dispatch(loaderAnimationShow());
      this.reportsServices.getReportLicenseToExcel(this.lastSubmitData).subscribe({
        next: (dataToExcel) => {
          const dataWithDateParsed = dataToExcel.map((data) => ({
            ...data,
            licenseExpirationDate: data.licenseExpirationDate ? dateToString(data.licenseExpirationDate) : '',
            requestDate: data.requestDate ? dateToString(data.requestDate) : '',
            manualSuspensionDate: data.manualSuspensionDate ? dateToString(data.manualSuspensionDate) : '',
            manualSuspensionDateFrom: data.manualSuspensionDateFrom ? dateToString(data.manualSuspensionDateFrom) : '',
            manualSuspensionDateTo: data.manualSuspensionDateTo ? dateToString(data.manualSuspensionDateTo) : '',
          }));
          exportToExcel(headers, dataWithDateParsed as any, 'Licencias ');
          this.store.dispatch(loaderAnimationHide());
        },
      });
    }
  }
}
